import React from 'react';
import Step from '../../interfaces/Step';
import { CheckIcon } from '@heroicons/react/solid';

interface PropsInterface {
  steps: Array<Step>;
  current: number;
}

const renderCircle = (step: Step, current: number) => {
  if (step.step < current) {
    return (
      <span className="circle rounded-full border-2 mb-4 flex items-center justify-center [transition:0.4s_ease] border-primary-medium bg-neutral-lightest w-5 h-5">
        <CheckIcon className="w-4 h-4 text-primary-dark" />
      </span>
    );
  }
  if (step.step === current) {
    return (
      <span className="circle rounded-full border-2 mb-4 flex items-center justify-center [transition:0.4s_ease] border-primary-medium bg-neutral-lightest w-6 h-6">
        <span className="rounded-full bg-primary-medium w-3 h-3" />
      </span>
    );
  }
  return (
    <span className="circle rounded-full border-2 mb-4 [transition:0.4s_ease] border-neutral-light bg-neutral-lightest w-4 h-4" />
  );
};

const ProgressStep = (props: PropsInterface) => {
  const total = props.steps.length;
  const activeIndex = props.steps.findIndex((s) => s.step === props.current);
  const completedCount = Math.max(0, activeIndex);

  return (
    <div className="container relative m-auto pt-6 max-w-3xl w-full">
      <div className="flex justify-between items-center relative max-w-full">
        {/* background line */}
        <div
          id="progress-bg"
          className="bg-neutral-light absolute top-[12px] h-[2px] z-0 rounded-full"
          style={{ left: '60px', right: '60px' }}
        />
        {/* active line */}
        <div
          className="bg-primary-medium absolute top-[12px] h-[2px] z-[1] rounded-full [transition:width_0.4s_ease]"
          style={{
            left: '60px',
            width:
              total > 1 && completedCount > 0
                ? `calc((100% - 120px) * ${completedCount} / ${total - 1})`
                : '0px',
          }}
        />
        {props.steps.map((item) => (
          <div
            key={item.step}
            className="relative z-[2] grid justify-center justify-items-center px-2 w-[120px]"
          >
            {renderCircle(item, props.current)}
            <span className="text-xs">{item.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressStep;
